exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container___28_Z- {\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  padding: 40px;\n}\n.circleIcon___29Mbg {\n  align-self: flex-start;\n}\n.body___QMeTu {\n  text-align: left;\n  font-weight: 600;\n  line-height: 28px;\n  margin-top: 32px;\n  margin-bottom: 40px;\n}\n.buttonContainer___1lzqs {\n  text-align: right;\n}\n", ""]);

// exports
exports.locals = {
	"container": "container___28_Z-",
	"circleIcon": "circleIcon___29Mbg",
	"body": "body___QMeTu",
	"buttonContainer": "buttonContainer___1lzqs"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/stylesheets/pages/PublishWebsiteModal.module.less
// module id = 2534
// module chunks = 71